// extracted by mini-css-extract-plugin
export default {"Subtitle":"Styles_Subtitle__LeTw5"};